import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { keys } from '@clubhub/constants/session-keys';
import { MarketingPreferencesService } from '@clubhub/services/marketing-preferences.service';
import { BannerComponent } from '@shared/components/banner/banner.component';
import { agencyNumbers, roles } from '@shared/constants';
import { contactUsPhone } from '@shared/constants/phone';
import { BannerName } from '@shared/models';
import { AnalyticsService, AuthorizeService, ModalService } from '@shared/services';

@Component({
  selector: 'app-home',
  styleUrls: ['home.component.scss'],
  templateUrl: 'home.component.html',
  imports: [BannerComponent, RouterLink],
})
export class HomeComponent implements OnInit, AfterViewInit {
  private readonly router = inject(Router);
  public readonly authService = inject(AuthorizeService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly modalService = inject(ModalService);
  private readonly marketingPreferencesService = inject(MarketingPreferencesService);
  public contactUsPhone = contactUsPhone;
  protected bannerName = BannerName.ClubHubHomepage;

  public ngOnInit() {
    this.authService.getUser().subscribe(() => {
      if (this.authService.hasRole(roles.mortgageClub)) {
        // stay on home page
      } else if (this.authService.hasRole(roles.broker) || this.authService.hasRole(roles.staff)) {
        this.router.navigate(['ignite', 'criteria', 'landing', 'home']);
      }
    });
    if (!this.marketingPreferencesSaved && this.isClubHub) {
      this.modalService
        .open({
          title: 'Marketing Preferences',
          message:
            'Would you like to set or update your marketing preferences?<br>You can update these later in the "My account" section.',
          showButtons: true,
          sticky: true,
          okLabel: 'Update Now',
          cancelLabel: 'Update Later',
        })
        .then(
          () => {
            this.updateMarketingPreferences();
          },
          () => {
            this.setMarketingPreferencesAsRead();
          },
        );
    }
  }

  public ngAfterViewInit() {
    this.analyticsService.log('ClubHub Home', 'L&G');
  }

  public get isIgnite() {
    return this.authService.isIgniteApp;
  }

  public get isClubHub() {
    return this.authService.isClubHubApp;
  }

  public get marketingPreferencesSaved() {
    return (
      this.authService.agencyNumber === agencyNumbers.lenderHubUserAgencyNumber || // Don't show to LenderHub users
      this.authService.user?.marketingPreferencesSaved?.toLowerCase() === 'true' ||
      sessionStorage.getItem(keys.marketingPreferencesSaved) === 'true'
    );
  }

  public setMarketingPreferencesAsRead() {
    this.marketingPreferencesService.setMarketingPreferencesAsRead().subscribe(() => {
      sessionStorage.setItem(keys.marketingPreferencesSaved, 'true');
    });
  }

  public updateMarketingPreferences() {
    this.marketingPreferencesService.setMarketingPreferencesAsRead().subscribe(() => {
      sessionStorage.setItem(keys.marketingPreferencesSaved, 'true');
      this.router.navigate(['/authentication/profile']);
    });
  }
}
